require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/header/main-header.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/header/main-header.legacy.js
// module id = 793
// module chunks = 33